import { createCRUDHook } from './createCRUDHook';
import { QuestionDto } from 'utils/models';
import { ECG_QUESTION } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<QuestionDto>({
  entityName: 'Question',
  endpoint: ECG_QUESTION,
});

export const QuestionContext = Context;
export const useQuestionManager = useManager;
export const useQuestion = useConsumer;
